/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import RouteLinkItem from 'components/navigation/side-navigation/item/RouteLinkItem';

const messages = defineMessages({
  title: {id: 'navigation.settings.health.templates'},
});

const TemplatesItem = () => (
  <RouteLinkItem
    route="midas/settings/health/templates"
    title={messages.title}
  />
);

export default TemplatesItem;
